import React, { useEffect, useMemo, useState } from 'react'
import styled, { css } from 'styled-components'
import Input from 'components/atoms/Input'
import Button from 'components/atoms/Button'
import { isNotNilOrEmpty } from 'utils/ramda'
import { changeQuery, getCurrentParsedQuery } from 'utils/navigation'
import { useHistory } from 'react-router-dom'
import { ButtonsWrapper } from 'theme/wrappers'
import { dissoc, propOr } from 'ramda'
import { INVENTORY_STATUSES } from 'utils/inventory'

const initialValues = {
  created_after: '',
  created_before: '',
  type: 'all',
  location: '',
  product: '',
  quantity: ''
}

const InventoryMoveLogsFilters = ({ open }) => {
  const [values, setValues] = useState(initialValues)
  const {
    location: { search }
  } = useHistory()

  const typeOptions = useMemo(() => {
    let items = [{ label: 'Wszystkie', value: 'all' }]
    for (let key in INVENTORY_STATUSES) {
      items = [...items, { label: INVENTORY_STATUSES[key], value: key }]
    }
    return items
  }, [])

  useEffect(() => {
    const currentQuery = getCurrentParsedQuery()
    setValues({
      ...initialValues,
      ...propOr({}, 'filter', currentQuery)
    })
  }, [search])

  const handleValueChange = (name, value) => {
    setValues(prev => ({ ...prev, [name]: value }))
  }

  const resetFiltersHandler = () => {
    setValues(initialValues)
    changeQuery({
      page: 1,
      sort: '-created_at'
    })
  }

  const submitHandler = () => {
    const currentQuery = getCurrentParsedQuery()
    let payload = {}

    for (let key in values) {
      if (isNotNilOrEmpty(values[key]) && values[key] !== 'all') {
        payload[key] = values[key]
      } else {
        payload = dissoc(key, payload)
      }
    }

    changeQuery({
      ...currentQuery,
      page: 1,
      filter: payload
    })
  }

  useEffect(() => {
    const currentQuery = getCurrentParsedQuery()
    setValues({
      ...initialValues,
      ...propOr({}, 'filter', currentQuery)
    })
  }, [search])

  return (
    <Wrapper open={open}>
      <Input
        type='date'
        value={values.created_after}
        name='created_after'
        label='Data od'
        onChange={handleValueChange}
        noMarginBottom
      />
      <Input
        type='date'
        value={values.created_before}
        name='created_before'
        label='Data do'
        onChange={handleValueChange}
        noMarginBottom
      />
      <Input
        clearable
        name='location'
        value={values.location}
        label='Lokalizacja'
        onChange={handleValueChange}
        noMarginBottom
      />
      <Input
        select
        options={typeOptions}
        name='type'
        value={values.type}
        label='Typ'
        onChange={handleValueChange}
        noMarginBottom
      />
      <Input
        clearable
        name='product'
        value={values.product}
        label='EAN'
        onChange={handleValueChange}
        noMarginBottom
      />
      <Input
        clearable
        name='quantity'
        value={values.quantity}
        label='Ilość'
        onChange={handleValueChange}
        noMarginBottom
      />
      <ButtonsWrapper>
        <Button small onClick={submitHandler} color='primary'>
          Zastosuj
        </Button>
        <Button small onClick={resetFiltersHandler} color='primary-outline'>
          Resetuj
        </Button>
      </ButtonsWrapper>
    </Wrapper>
  )
}

export default InventoryMoveLogsFilters

const Wrapper = styled.div`
  background-color: #fff;
  border-radius: 4px;
  box-shadow: ${({ theme }) => theme.shadows.main};
  width: 100%;
  overflow: hidden;
  height: 0;
  padding: 0 20px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 15px;

  ${({ open }) =>
    open &&
    css`
      padding: 20px;
      margin-bottom: 20px;
      height: 110px;
    `}
`
